// TODO: This should just be moved into the same directory as the Profile Edit pages

import React, { useState } from 'react';
import { PropTypes } from 'prop-types';
import { Formik } from 'formik';
import * as Yup from 'yup';
import classNames from 'classnames';
import jsCookie from 'js-cookie';
import { useErrorHandler } from 'react-error-boundary';
import styled from 'styled-components';
import SectionHeader from '../../../_molecules/SectionHeader';

// Components
import AccountMobileSubnav from '../Account/AccountMobileSubnav';
import EditProfileForm from '../../../_molecules/EditProfileForm';
import ErrorHandler from '../../../_molecules/ErrorHandler';
import PageTitle from '@atoms/PageTitle';
import PageTitleSub from '@atoms/PageTitleSub';
import SubmitButton from '@atoms/SubmitButton';
import EditProfileNavLink from '@molecules/EditProfileNavLink';
import LoadingArea from '@molecules/LoadingArea';
import {BodyLarge, DividerLightGreyStyled, H3, LinkSmall} from '@styled';

// Functionality
import { transformFormToViewer, transformViewerToForm } from '../../../../helpers/editForm.helpers';
import useViewer from '@hooks/useViewer';
import useViewerUpdate from '@hooks/useViewerUpdate';
import useDocumentTitle from '@hooks/useDocumentTitle';
import SectionBreadcrumbs from "../../../_molecules/SectionBreadcrumbs";
import SectionBreadcrumb from "../../../_molecules/SectionBreadcrumb";

const OverlayStyled = styled.div`
    height: 100%;
    width: 100%;
    position: fixed;
    z-index: 1;
    left: 0;
    top: 0;
    background-color: rgb(0, 0, 0);
    background-color: rgba(0, 0, 0, 0.2);
    overflow-x: hidden;
    transition: 0.5s;
`;

const EditProfileFormSection = ({
    children,
    validationSchema,
    pageTitleSub,
    prevNavLink,
    prevNavLabel,
    nextNavLink,
    nextNavLabel,
}) => {
    const { loading, error, viewer } = useViewer();
    useDocumentTitle(`Edit Profile - ${pageTitleSub}`);
    useErrorHandler(error);

    const [isSuccessfulUpdate, setIsSuccessfulUpdate] = useState(false);
    const [isErrorUpdate, setIsErrorUpdate] = useState(false);
    const [emailError, setEmailError] = useState(null);

    const { updateViewer, isLoading: isLoadingUpdate, error: isError } = useViewerUpdate({
        onCompleted: () => {
            setIsSuccessfulUpdate(true);
            jsCookie.set('my_icsc_updated', 1);
            setTimeout(() => {
                setIsSuccessfulUpdate(false);
            }, 2000);
        },
        onError: e => {
            if (typeof e === 'string' && e.toUpperCase().includes('EMAIL')) {
                setEmailError('This email is already taken');
            }

            // console.log(e);

            setIsErrorUpdate(true);
            // setTimeout(() => {
            //     setIsErrorUpdate(false);
            // }, 3000);
        },
    });

    const onSubmit = values => {
        const newViewer = transformFormToViewer(values);
        updateViewer({ variables: newViewer });
    };

    const getInitialErrors = () => {
        return {
            email: emailError,
        };
    };

    const getInitialValues = () => {
        if (!viewer) return {};

        try {
            return transformViewerToForm(viewer);
        } catch (e) {
            // console.log(e);
        }
    };

    if (loading) {
        return (
            <div className="p-4 col-md-9 px-md-7">
                <LoadingArea />
            </div>
        );
    }

    const navClasses = classNames({
        'd-flex': true,
        'justify-content-between': prevNavLink && nextNavLink,
        'justify-content-end': !prevNavLink && nextNavLink,
    });

    if (!viewer) return null;

    return (
        <ErrorHandler>
            <div className="p-4 fade-in-fast">
                {isLoadingUpdate && <OverlayStyled />}
                <div className="mb-3 mx-md-4">
                    <SectionHeader title="My Account" />

                    <div className="flex justify-content-between mt-2">
                        <SectionBreadcrumbs>
                            <SectionBreadcrumb route="/my-icsc/account">My Account</SectionBreadcrumb>
                            <SectionBreadcrumb route="/my-icsc/account/edit-profile">Edit Profile</SectionBreadcrumb>
                            <SectionBreadcrumb isActive>{pageTitleSub}</SectionBreadcrumb>
                        </SectionBreadcrumbs>
                    </div>

                    <H3 className="mt-3 mb-4">Edit Profile</H3>
                    <BodyLarge>{pageTitleSub}</BodyLarge>

                    <AccountMobileSubnav />

                    <Formik
                        onSubmit={onSubmit}
                        enableReinitialize
                        initialErrors={getInitialErrors()}
                        initialValues={getInitialValues()}
                        validationSchema={Yup.object(validationSchema)}
                    >
                        {() => (
                            <EditProfileForm>
                                {children}
                                <SubmitButton
                                    buttonClasses="editprofile"
                                    style={{position: 'sticky', bottom: '1rem'}}
                                    isSubmitting={isLoadingUpdate}
                                    isSuccessful={isSuccessfulUpdate}
                                    isError={isErrorUpdate}
                                >
                                    Save Profile
                                </SubmitButton>
                            </EditProfileForm>
                        )}
                    </Formik>
                    <DividerLightGreyStyled className="mt-5 mb-4"/>
                    <div className={navClasses}>
                        {prevNavLink && (
                            <EditProfileNavLink type="prev" to={prevNavLink}>
                                {prevNavLabel}
                            </EditProfileNavLink>
                        )}
                        {nextNavLink && (
                            <EditProfileNavLink type="next" to={nextNavLink}>
                                {nextNavLabel}
                            </EditProfileNavLink>
                        )}
                    </div>
                </div>
            </div>
        </ErrorHandler>
    );
};

EditProfileFormSection.propTypes = {
    validationSchema: PropTypes.object,
    children: PropTypes.array,
    pageTitleSub: PropTypes.string,
    prevNavLink: PropTypes.string,
    prevNavLabel: PropTypes.string,
    nextNavLink: PropTypes.string,
    nextNavLabel: PropTypes.string,
};

export default EditProfileFormSection;
